import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseURL } from "../../BaseUrl";
// Function to retrieve token from localStorage
const getToken = () => localStorage.getItem("workManagement");

// API headers including token
const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`,
  },
});
export const getAlldepartmentdata = createAsyncThunk(
    "department/getAlldepartmentdata",
    async () => {
      try {
        const response = await baseURL.get(`/department/`,getAuthHeaders());
        // console.log("response.data", response.data);
        return response.data.data;
      } catch (error) {
        // alert(`${error.response.data.message}`)
        throw error; // Ensure the error is propagated
      }
    }
  );
  export const createdepartmentdata = createAsyncThunk(
    "department/createdepartmentdata",
    async (data) => {
      try {
        // console.log("authtnk", getAuthHeaders())
        const response = await baseURL.post(`/department/`,data,getAuthHeaders()
        );
        // console.log("response.data", response.data);
        return response.data.data;
      } catch (error) {
        // alert(`${error.response.data.message}`)
        throw error; // Ensure the error is propagated
      }
    }
  );
  export const getSingledepartmentdata = createAsyncThunk(
    "department/getSingledepartmentdata",
    async (id) => {
      try {
        // console.log("authtnk", getAuthHeaders())
        const response = await baseURL.get(`/department/${id}`,getAuthHeaders());
        // console.log("response.data", response.data);
        return response.data.data;
      } catch (error) {
        // alert(`${error.response.data.message}`)
        throw error; // Ensure the error is propagated
      }
    }
  );
  export const updatedepartmentdata = createAsyncThunk(
    "department/updatedepartmentdata",
    async (data) => {
      try {
        // console.log("authtnk", getAuthHeaders())
        const response = await baseURL.patch(`/department/`,data,getAuthHeaders()
        );
        // console.log("response.data", response.data);
        return response.data.data;
      } catch (error) {
        // alert(`${error.response.data.message}`)
        throw error; // Ensure the error is propagated
      }
    }
  );
  //delete 
export const deleteUnitData = createAsyncThunk(
  "unit/deleteUnitData",
  async (id) => {
    // console.log("cid===>",cid)
    try {
      const response = await baseURL.delete(`/department/${id}`,getAuthHeaders());
      // console.log("response.data", response.data)
      return response.data.data;
    } catch (error) {
      // alert(`${error.response.data.message}`)
      throw error; // Ensure the error is propagated
    }
  }
);
  export const departmentSlice = createSlice({
    name: "department",
    initialState: {
      departmentData: [],
      singleDepartmentData:{},
      loading: false,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(getAlldepartmentdata.pending, (state) => {
          state.loading = true;
        })
        .addCase(getAlldepartmentdata.fulfilled, (state, action) => {
          state.loading = false;
          state.departmentData = action.payload;
        })
        .addCase(getAlldepartmentdata.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error;
        });
        builder
        .addCase(getSingledepartmentdata.pending, (state) => {
          state.loading = true;
        })
        .addCase(getSingledepartmentdata.fulfilled, (state, action) => {
          state.loading = false;
          state.singleDepartmentData = action.payload;
        })
        .addCase(getSingledepartmentdata.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error;
        });
    },
  });
  
  // SELECTORS
  export const getDepartmentData = (state) => state.department.departmentData;
  export const getUniqueDepartmentData = (state) => state.department.singleDepartmentData;
    export const departmentError = (state) => state.department.loading;
  
  // EXPORTS
  export default departmentSlice.reducer;
  